import { MATERIAL_IDS } from "src/api";

import { MATERIAL_DISPLAY } from "../../constants";
import { useSessionView } from "../../game/useSessionView";
import { Icon } from "../icons/Icon";
import { StyledButtonContainer } from "../shared/StyledButtonContainer";
import "./MaterialCounter.css";

export function MaterialCounter() {
  const view = useSessionView();
  const stock = view?.readouts.mine.stock ?? [];

  return (
    <StyledButtonContainer className="material-counter">
      <div className="material-counter-row">
        {MATERIAL_IDS.map((id) => {
          const { label, color, icon: iconName } = MATERIAL_DISPLAY[id];
          const count =
            stock.find((holding) => holding.material === id)?.count ?? 0;
          let icon = (
            <div
              className="material-counter-icon"
              style={{ backgroundColor: color }}
            />
          );
          if (iconName)
            icon = <Icon icon={iconName} className="material-counter-icon" />;
          return (
            <div key={id} className="material-counter-slot" title={label}>
              {icon}
              <div className="material-counter-count">{count}</div>
            </div>
          );
        })}
      </div>
    </StyledButtonContainer>
  );
}
